module.exports = __webpack_public_path__ + "static/media/jetson_one_render_12.02e11397.jpg";